import React, { useState, useEffect } from 'react';
import { Column, Card, Notification, Delete, Progress, Tag } from 'rbx';
import GeneralService from '../../services/general';
import { milharMask } from '../../commons/masks';

const styleHr = {
  backgroundColor: 'transparent',
  borderColor: 'rgb(221, 221, 221)',
  borderStyle: 'dashed',
  borderWidth: '1px 0px 0px',
  margin: '15px 0',
};

const initialValues = {
  codigoDistribuidor: '0',
  saldoBloqueado: '0',
  saldoDesbloqueado: '0',
  totalAtivado: '0',
  totalCadsInUse: '0',
};

const DistributorBalances = () => {
  const minCadsAvailableUserApp = parseInt(
    process.env.REACT_APP_MIN_CADS_AVAILABLE_USER_APP,
  );
  const minCadsAvailableUserPdv = parseInt(
    process.env.REACT_APP_MIN_CADS_AVAILABLE_USER_PDV,
  );

  const [activeProgress, setActiveProgress] = useState(true);
  const [balancesApp, setBalancesApp] = useState(initialValues);
  const [balancesPdv, setBalancesPdv] = useState(initialValues);

  const [status, setStatus] = useState('');

  useEffect(() => {
    fetchBalances();
  }, []);

  const fetchBalances = async () => {
    try {
      const response = await GeneralService.balances();
      const balancesAppTemp = response.data.balances.app;
      const balancesPdvTemp = response.data.balances.pdv;

      const response2 = await GeneralService.totalCadsInUse('1'); // User App
      const response3 = await GeneralService.totalCadsInUse('2'); // User PDV

      setBalancesApp({
        ...balancesAppTemp,
        totalCadsInUse: response2.data.history.length,
      });

      setBalancesPdv({
        ...balancesPdvTemp,
        totalCadsInUse: response3.data.history.length,
      });

      if (
        parseInt(balancesAppTemp.saldoBloqueado) <= minCadsAvailableUserApp ||
        parseInt(balancesPdvTemp.saldoBloqueado) <= minCadsAvailableUserPdv
      )
        setStatus([
          'danger',
          "Atenção: CAD's Disponíveis à Venda atingiu a quantidade mínima!!",
        ]);
      else setStatus('');
    } catch (e) {
      if (e.response)
        setStatus([
          'danger',
          `${e.response.status}: ${e.response.data.errors}`,
        ]);
      else setStatus(['danger', `${e.message}`]);
    }
    setActiveProgress(false);
  };

  return (
    <>
      {status !== '' && (
        <Notification color={status[0]}>
          <Delete onClick={() => setStatus('')} />
          {status[1]}
        </Notification>
      )}

      <Card>
        <Card.Header>
          <Card.Header.Title style={{ display: 'inline' }}>
            <Column.Group breakpoint="mobile">
              <Column>
                Veículos estacionados agora: {balancesApp.totalCadsInUse}
              </Column>
              <Column textAlign="centered">
                APP
                {/* [Distribuidor: {balancesApp.codigoDistribuidor}] */}
              </Column>
              <Column textAlign="centered">
                PDV
                {/* [Distribuidor: {balancesPdv.codigoDistribuidor}] */}
              </Column>
            </Column.Group>
          </Card.Header.Title>
        </Card.Header>
        <Card.Content style={{ padding: '1rem' }}>
          <Column.Group breakpoint="mobile">
            <Column>CAD’s Disponíveis para Venda:</Column>
            <Column textAlign="centered">
              {parseInt(balancesApp.saldoBloqueado) <=
              minCadsAvailableUserApp ? (
                <Tag size="medium" color="danger" rounded>
                  {milharMask(balancesApp.saldoBloqueado)}
                </Tag>
              ) : (
                milharMask(balancesApp.saldoBloqueado)
              )}
            </Column>
            <Column textAlign="centered">
              {parseInt(balancesPdv.saldoBloqueado) <=
              minCadsAvailableUserPdv ? (
                <Tag size="medium" color="danger" rounded>
                  {milharMask(balancesPdv.saldoBloqueado)}
                </Tag>
              ) : (
                milharMask(balancesPdv.saldoBloqueado)
              )}
            </Column>
          </Column.Group>
          <hr style={styleHr} />

          <Column.Group breakpoint="mobile">
            <Column>CAD’s Vendidos (Não Utilizados):</Column>
            <Column textAlign="centered">
              {milharMask(balancesApp.saldoDesbloqueado)}
            </Column>
            <Column textAlign="centered">
              {milharMask(balancesPdv.saldoDesbloqueado)}
            </Column>
          </Column.Group>
          <hr style={styleHr} />

          <Column.Group breakpoint="mobile">
            <Column>Total de CAD’s Utilizados:</Column>
            <Column textAlign="centered">
              {milharMask(balancesApp.totalAtivado)}
            </Column>
            <Column textAlign="centered">
              {milharMask(balancesPdv.totalAtivado)}
            </Column>
          </Column.Group>
          {/* <hr style={styleHr} />

          <Column.Group breakpoint="mobile">
            <Column>Total de CAD’s em Uso no Momento:</Column>
            <Column textAlign="centered">{balancesApp.totalCadsInUse}</Column>
            <Column textAlign="centered">{balancesPdv.totalCadsInUse}</Column>
          </Column.Group> */}
        </Card.Content>
      </Card>

      {activeProgress && <Progress size="small" color="custom-purple" />}
    </>
  );
};

export default DistributorBalances;
